import React from 'react';
import { useTranslation } from 'react-i18next';

import { PetItem } from './common';
import {
  DATE_FORMATS,
  formatDateByLanguage,
} from '../../services/language.utils';
import { PET_DEMOS_SPECIES } from '../../constants';

import styles from './IneligiblePetItem.module.css';

const IneligiblePetItem = ({
  petName = '',
  dateOfBirth = '',
  removalDate = '',
  specie = PET_DEMOS_SPECIES.dog,
}) => {
  const { t } = useTranslation('petDemos');

  const formattedDob = formatDateByLanguage({
    date: dateOfBirth,
    dateFormat: DATE_FORMATS.long,
  });

  return (
    <div className={styles.ineligiblePetItem}>
      <p className={styles.ineligibilityDescription}>
        {t('reviewIneligiblePets.ineligibilityReason', {
          dateOfBirth: formattedDob,
        })}
      </p>

      <span className={styles.removalDateText}>{removalDate}</span>

      <p className={styles.ineligibilityDescriptionMobile}>
        {t('reviewIneligiblePets.ineligibilityReasonMobile')}
      </p>

      <div>
        <PetItem
          className={styles.petItemPill}
          iconClassName={styles.petIcon}
          isIneligible
          label={petName}
          specie={specie}
        />
      </div>
    </div>
  );
};

export { IneligiblePetItem };
